import { recordInformation } from "components/DetailPage/RecordInformation";
import { FreefieldState } from "shared/utils/freeFields/models";
import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import React from "react";
import { freeFieldEditableSections } from "show/components/freeFields/freeFieldEditableSections";
import { artistSection } from "./sections/artistSection";
import { hotelSection } from "./sections/hotelSection";
import { mainSection } from "./sections/mainSection";
import { promoterSection } from "./sections/promoterSection";
import { ticketsSection } from "./sections/ticketsSection";
import { venueSection } from "./sections/venueSection";
import { ShowInfo } from "./utils";
import { useIsExternal } from "common/SessionContext";

interface ShowDetailSectionProps {
  show: server.dto.Show
  showInfo: ShowInfo
  tags: server.dto.TagSmall[]
  promoterCompany: server.dto.Company
  promoterContact: server.dto.Contact
  venueContact: server.dto.Contact
  hotelContact: server.dto.Contact
  exclusivityClause: server.dto.ExclusivityClause
  ffState: FreefieldState
  onValueChanged: (key: string, value: any) => Promise<void>
  onSuccessfulUpdate: (key: string, newValue: any) => Promise<void>
}

export const ShowDetailSection = (props: ShowDetailSectionProps) => {
  const isExternal = useIsExternal();
  const { show, showInfo, tags, promoterCompany, promoterContact, venueContact, hotelContact, ffState } = props;

  return <DetailSectionTemplate
    onValueChanged={props.onValueChanged}
    onSuccessfulUpdate={props.onSuccessfulUpdate}

    // Don't set this to show.permissions.canModify
    // Because a user can have no access to modify a show, but can still modify free field persmi
    isInPageEditable={show.permissions.canModify}
    sections={[
      mainSection(show, showInfo, tags, isExternal),
      artistSection(show, showInfo, isExternal, false),
      venueSection(show, showInfo, venueContact, isExternal, false),
      promoterSection(show, showInfo, promoterCompany, promoterContact, isExternal, false),
      hotelSection(show, showInfo, hotelContact, isExternal, false),
      ticketsSection(show, showInfo, isExternal),
      ...freeFieldEditableSections(
        show.showId,
        ffState.freefieldCategoriesWithValuesAndPermissions,
        window.CoreApi.Show.UpdateFreeField,
      ),
      recordInformation(
        show.createdUtc,
        show.createdUser,
        show.lastModifiedUtc,
        show.lastModifiedUser,
        show.showId
      ),
    ]}
  />;
};
